import { Routes } from "@angular/router";
import { BottomtabsComponent } from "src/app/layouts/bottomtabs/bottomtabs.component";
import { HOME_ROUTES } from "./home";

export const LAYOUT_ROUTES: Routes = [
    {
      path: 'bottomtabs', component: BottomtabsComponent, children: HOME_ROUTES
    }
]